var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalTwinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18.9343L13.0986 20L11.5 21.0657V18.9343Z",
    fill: "currentColor",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16259 11.708C2.49445 12.0548 1.91707 12.4472 1.45377 12.8815C0.865106 13.4333 0.447224 14.0659 0.281264 14.764C0.112308 15.4748 0.220446 16.189 0.575603 16.8526C1.26011 18.1316 2.80716 19.1368 4.76266 19.8264C6.53689 20.4522 8.6714 20.8279 10.8955 20.9216V19.4202C8.81661 19.3272 6.85591 18.9741 5.26156 18.4118C3.42491 17.7641 2.31607 16.9258 1.89811 16.1448C1.70204 15.7784 1.66292 15.4377 1.74059 15.111C1.82127 14.7716 2.04391 14.3843 2.47958 13.9759C2.67409 13.7936 2.90238 13.6153 3.16259 13.4432V11.708ZM20.8378 13.4432C21.1895 13.6759 21.4815 13.9187 21.7101 14.1661C22.083 14.5698 22.2503 14.9446 22.2884 15.2721C22.3256 15.5922 22.2484 15.9422 21.9945 16.3245C21.4608 17.1283 20.2212 17.95 18.3065 18.5563C17.0882 18.9422 15.6894 19.2108 14.2096 19.3455V20.8513C15.8353 20.7123 17.3894 20.4202 18.7594 19.9864C20.7931 19.3424 22.4283 18.3829 23.2441 17.1543C23.665 16.5205 23.8622 15.8202 23.7783 15.0988C23.6953 14.3846 23.346 13.7264 22.8119 13.1483C22.311 12.6061 21.6392 12.1239 20.8378 11.708V13.4432Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.18182L11.5714 3L18 5.90588M18 5.90588L12 8.65882L6 5.90588V13.0941L11.8571 16M18 5.90588V13.0941L11.8571 16M11.8571 16V11.2727",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalTwinIcon);
export default __webpack_public_path__ + "static/media/digital-twin-icon.eb879bda7ed075c80e56fdb31023a48e.svg";
export { ForwardRef as ReactComponent };